<template>
  <v-container class="item" :class="$store.state.dark && 'dark-bg'">
    <h1 v-text="$route.params.title"></h1>
    <div v-html="$route.params.content.replace(/<img /gi, '<img loading=lazy ')"></div>
  </v-container>
</template>

<script>
export default {
  setup(_, ctx) {
    if (!ctx.root.$route.params.title) ctx.root.$router.replace('/')
  },
}
</script>

<style lang="sass">
.item
  padding: 16px
  min-height: 100vh
  background-color: #f9f5e9
  h1
    font-size: 18px
    font-weight: lighter
    padding-bottom: 10px
    margin-bottom: 20px
    border-bottom: dashed 1px #222
  ul
    padding: 0
  p,li,a
    text-indent: 2em
    line-height: 2em
    letter-spacing: 2px
    >img,iframe
      position: relative
      left: -2em
  iframe
    width: 100%
</style>

<style>
  .comilla-cerrar{
    padding: 20px 40px;
    color: #999;
  }
  .articulo-titulo{
    margin-top: 20px;
    margin-bottom: 10px;
    font-weight: 300;
  }
</style>